import React from 'react';

const MyRequests = ({ myRequests, loadingRequests, requestsError, setCurrentView }) => (
    <div id="myRequestsView" className="form-container">
        <h2>Мои заявки</h2>
        {loadingRequests && <p>Загрузка заявок...</p>}
        {requestsError && <p className="error-message">{requestsError}</p>}
        {!loadingRequests && !requestsError && myRequests.length === 0 && (
            <p>У вас пока нет заявок.</p>
        )}
        {!loadingRequests && !requestsError && myRequests.length > 0 && (
            <div className="requests-table-wrapper">
                <table>
                    <thead>
                        <tr>
                            <th>Тип</th>
                            <th>Сумма</th>
                            <th>Детали</th>
                            <th>Дата</th>
                            <th>Статус</th>
                        </tr>
                    </thead>
                    <tbody>
                        {myRequests.map((req, index) => (
                            <tr key={index}>
                                <td>
                                    {req.type === 'buyUSDT' && 'Купить USDT'}
                                    {req.type === 'sellUSDT' && 'Продать USDT'}
                                    {req.type === 'alipayWechat' && 'Alipay/Wechat'}
                                    {req.type === 'reschedule' && 'Перестановка'}
                                </td>
                                <td>
                                    {req.amount_rub || req.amount}
                                    {req.type === 'buyUSDT' || req.type === 'sellUSDT' || req.type === 'alipayWechat' ? ' RUB' : ' RUB'}
                                </td>
                                <td>
                                    {req.type === 'buyUSDT' && `Банк: ${req.bank}, ФИО: ${req.sender_name}`}
                                    {req.type === 'sellUSDT' && `ФИО: ${req.receiver_name}`}
                                    {req.type === 'alipayWechat' && `Банк: ${req.bank}, ФИО: ${req.sender_name}`}
                                    {req.type === 'reschedule' && `Отдать: ${req.city_give}, Получить: ${req.city_receive}`}
                                </td>
                                <td>{new Date(req.created_at).toLocaleString()}</td>
                                <td>
                                    {req.status === 'waiting' && 'В процессе'}
                                    {req.status === 'canceled' && 'Отменена'}
                                    {req.status === 'done' && 'Выполнена'}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        )}
        <button type="button" className="back-to-main-menu-button" onClick={() => setCurrentView('mainMenu')}>Назад в главное меню</button>
    </div>
);

export default MyRequests;